import { watch } from 'vue';
import { storeToRefs } from 'pinia';
import {
  useShipmentFormStore,
  type ShipmentFormSelectedDevice,
} from '@/stores/useShipmentFormStore';

export function useShipmentFormNameAutofill() {
  const formStore = useShipmentFormStore();
  const { selectedDevices, generalName } = storeToRefs(formStore);

  function applyFromPrimaryDevice(): void {
    const primary = selectedDevices.value[0];
    if (!primary) return;
    if (!formStore.isNameAutofillUntouched()) return;
    formStore.setNameAutofillFromDevice(primary.id, primary.label);
  }

  function onDeviceSelectionChanged(devices: ShipmentFormSelectedDevice[]): void {
    const primary = devices[0];
    if (!primary) return;
    if (!formStore.isNameAutofillUntouched()) return;
    formStore.setNameAutofillFromDevice(primary.id, primary.label);
  }

  function onGeneralNameInput(value: string): void {
    generalName.value = value;
  }

  watch(
    selectedDevices,
    (devices) => {
      onDeviceSelectionChanged(devices);
    },
    { deep: true },
  );

  return {
    applyFromPrimaryDevice,
    onDeviceSelectionChanged,
    onGeneralNameInput,
  };
}
